import styles from './SectionCardHeader.module.scss';
import Markdown from "@/components/atoms/Markdown";
import { remark } from "remark";
import html from "remark-html";
import clsx from 'clsx';

export default function SectionCardHeader({
    hideHr,
    className,
    Title,
    rootClassName,
    isCard,
    isLandings,
    wide,
    children
}: {
    hideHr?: boolean;
    className?: string;
    Title?: { enabled: boolean; text: string };
    rootClassName?: string;
    isCard?: boolean;
    isLandings?: boolean;
    wide?: boolean;
    children?: React.ReactNode;
}) {
    const Hed = Title;
    const title = Hed?.enabled ? (
        remark().use(html).process(Hed.text?.replace(/\n/gi, "  \n"))
    ).toString() : "";

    return (
        <section className={`${className}`}>
            <div className="container">
                <div
                    className={clsx(
                        isLandings ?
                            styles.lproot :
                            styles.root,
                        {
                            [styles.card]: isCard,
                            [styles.wide]: wide
                        },
                        rootClassName,
                    )}
                >
                    {title && (
                        <Markdown
                            as="h2"
                            className={styles.title}
                        >
                            {title?.replace(/<\/?p[^>]*>/g, '')}
                        </Markdown>
                    )}

                    {!hideHr && <div className={styles.hr} />}

                    {children}
                </div>

            </div>
        </section>
    );
}
